import { css } from '@/styled-system/css';

export const spokeContainer = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

// The single source of padding/spacing for the ListingCard + ContactForm pair —
// both are plain, unpadded children that just fill this container.
export const spokeContent = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
  padding: 'loose',
});

export const successContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 'layout.vast.default loose',
  textAlign: 'center',
  gap: 'default',
  // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- keeps spoke success state vertically balanced
  minHeight: '300px',
});

export const successTitle = css({
  fontSize: 'heading-sm',
  fontWeight: 'bold',
  color: 'text.neutral',
});

export const successBody = css({
  fontSize: 'body',
  color: 'text.subtle',
});
